
<template>
  <div>
    
    <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      @click="addNew"
    >
      <feather-icon
        icon="PlusIcon"
        class="mr-50"
      />
      <span class="align-middle">{{$t('AddNew')}}</span>
    </b-button>

    <Grid :service="service" route_name="employees"></Grid>
  </div>
</template>


<script>
import { BButton } from 'bootstrap-vue'

import EmployeeService from '@/services/api/EmployeeService'

export default {
  directives: {
  },
  components: {
    BButton,
  },
  data: () => ({
    selected: [],
    service: null
  }),
  methods: {
    addNew() {
      this.$store.commit('naturalEntity/UPDATE_NATURAL_ENTITY', null)
      this.$router.push('/people/employees/create')
    }
  },
  beforeMount() {
    this.service = EmployeeService.build(this.$vs)
  }
}
</script>